const exportToCsv = (filename, rows, headerMap = {}) => {
  if (!rows || !rows.length) return;

  const headers = Object.keys(rows[0]);
  const displayHeaders = headers.map(h => headerMap[h] || h);

  const csv = [
    displayHeaders.join(','),
    ...rows.map(row =>
      headers.map(h => {
        const cell = row[h];
        if (cell == null) return '';
        const str = String(cell);
        return str.includes(',') || str.includes('"')
          ? `"${str.replace(/"/g, '""')}"`
          : str;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportToCsv;
